import { useGlobalConfigContext } from 'GlobalConfig.context';
import CustomFontLoader from './CustomFontLoader';

const FONT_TYPES = {
  default: 'default',
  custom: 'custom',
};

// eslint-disable-next-line react/prop-types
const FontLoader = ({ children }) => {
  const globalConfig = useGlobalConfigContext();
  const { defaultFontType, customFontFiles, selectedFontType } =
    globalConfig.config.fonts;

  if (selectedFontType === FONT_TYPES.custom) {
    return (
      <CustomFontLoader
        customFontFiles={customFontFiles}
        fallbackFont={defaultFontType}
      >
        {children}
      </CustomFontLoader>
    );
  }

  return <div style={{ fontFamily: defaultFontType }}>{children}</div>;
};

export default FontLoader;
